<template>
  <div>
<!-- 
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="breadcrumb-container">
      <router-link to="/atencion">Atenciones</router-link> >
      <router-link :to="'/atencionform/' + p_idAtencion ">Atención {{ p_numero }}</router-link> 
      > Tratamiento
    </div>
    <hr />
-->
    <!-- Modal -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
<!--             <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTratamiento" class="form-label">IdTratamiento</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="idTratamiento" name="idTratamiento"
                    v-model="datoTratamiento.idTratamiento" disabled>
                </div>
              </div>
            </div> -->
            <!-- Botón Lista de Valores  Atencion -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                  <select class="form-select" id="tipo" name="tipo" v-model="datoTratamiento.tipo" :disabled="!estadoPermitido" required>
                    <option value="" disabled selected>Seleccione una opción</option>
                    <option value="D">Diagnóstico</option>
                    <option value="T">Terapéutico</option>
                    <option value="E">Educacional</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="observacion" name="observacion"
                    v-model="datoTratamiento.observacion" style='text-transform:uppercase' :disabled="!estadoPermitido" required>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <div class="me-auto">
            <button type="button" class="btn btn-light" @click="verPedidosLaboratorio()">
              <span class="material-symbols-outlined" style="font-size: 48px; color: red;">labs</span>
              Solicitud de Laboratorio
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <button type="button" class="btn btn-light" @click="verPedidosImagen()">
              <span class="material-symbols-outlined" style="font-size: 48px; color: darkkhaki;">radiology</span>
              Solicitud de Imagen
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <button type="button" class="btn btn-light" @click="verReceta()">
              <span class="material-symbols-outlined" style="font-size: 48px; color: green;">prescriptions</span>
              Receta
            </button>
          </div>
<!--		  
          <button type="submit" class="btn btn-success" @click.prevent="guardarTratamiento" v-if="btnCrear"
            title="Guardar">
            <span class="material-symbols-outlined align-middle" style="font-size:32px;">
              save
            </span> Guardar
          </button>
-->		  
          <button type="submit" class="btn btn-success" @click.prevent="guardarEditTratamiento" v-if="btnEditar&&estadoPermitido"
            title="Actualizar">
<span class="material-symbols-outlined align-middle" style="font-size:32px;">
  update
</span> Actualizar 
          </button>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
// import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";

export default {
  props: {
    p_idAtencion: {
      type: Number,
      required: true
    },
    p_estadoAtencion: {
      type: String,
      required: true
    },
    p_numero: {
      type: String,
      required: true
    }
  },
  components: {
    // Layout,
    Footer 
  },
  data() {
    return {
      tratamientos: [],
      datoTratamiento: {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: true,
      modalWindow: true,
//      p_idTratamiento: 0,
      // p_numero: 0,
      atencions: [],
      showTable: 'pedido', // Pestaña por defecto
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
  },
  mounted() {
//    this.p_idTratamiento = this.$route.params.p_idtratamiento
    // this.p_idAtencion = this.$route.params.p_idatencion
    // this.p_numero = this.$route.params.p_numero
    this.getData()
/*     this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda() */
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getData() {
      api.get('/vwtratamientos/idatencion/' + this.p_idAtencion)
        .then(response => {
          this.datoTratamiento = response.data;
        })
        .catch(error => {
          console.error('Error al obtener datos de la persona:', error);
        });
    },
/*	
    async guardarTratamiento() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/tratamientos', this.datoTratamiento)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Tratamiento creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
*/	
    verReceta() {
      this.$router.push('/receta_recetadet/' + this.p_idAtencion + '/' + this.p_estadoAtencion + '/' + this.p_numero);
    },
    verPedidosImagen() {
      this.$router.push('/pedido_pedidodet/' + this.p_idAtencion + '/' + this.p_estadoAtencion + '/I' + '/' + this.p_numero);
    },
    verPedidosLaboratorio() {
      this.$router.push('/pedido_pedidodet/' + this.p_idAtencion + '/' + this.p_estadoAtencion + '/L' + '/' + this.p_numero);
    }  
  },
}
</script>
<style src="@/assets/css/tabs.css" scoped></style>
